/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *|
 *| IBM Cognos Products: Dashboard
 *|
 *| (C) Copyright IBM Corp. 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define(function() {
	'use strict';
	class Rave2heat {
		get config(){
			return {
				'type': 'Heatmap',
				'propertiesToSetBeforeData': [
					'widget.data.truncate'
				],
				'listenForPropChanges':[
					'widget.legend.size'
				],
				'slots':{
					'categories':{
						'sort':'asc',
						'icon':'row_heading',
						'tags':['badge'],
						'mldTitleProperty': 'itemAxis.title'
					},
					'series':{
						'sort':'asc',
						'icon':'column_heading',
						'tags':['badge'],
						'mldTitleProperty': 'valueAxis.title'
					},
					'points':{
						'icon':'points'
					},
					'color':{
						'icon':'heat_map',
						'mldTitleProperty': 'color.title',
						'tags': ['canUseToColor']  //canUseToColor indicates that smart color feature could be applicable to the data item in this slot
					},
					'size':{
						'icon':'size_by',
						'mldTitleProperty': 'size.title'
					},
					'repeatHorizontal':{
						'icon':'multiplier_h',
						'sort':'asc'
					},
					'repeatVertical':{
						'icon':'multiplier_v',
						'sort':'asc'
					}
				},
				'propertyPrefixes': {
					'dataPoint': 'itemAxis.ticks.labels',
					'categories': 'valueAxis.title',
					'series': 'itemAxis.title',
					'color': 'widget.legend',
					'size': 'widget.legend',
					'row': 'widget.repeatVertical.labels',
					'column': 'widget.repeatHorizontal.labels'
				},
				'groupedProperty': {
					'widget.legend.color': ['widget.legend.titleColor'],
					'widget.legend.font': ['widget.legend.titleFont'],
					'itemAxis.ticks.labels.color': ['valueAxis.ticks.labels.color'],
					'itemAxis.ticks.labels.font': ['valueAxis.ticks.labels.font']
				},
				'elementStyle': {
					'groupedAxes': [
						['itemAxis.ticks.labels','valueAxis.ticks.labels'],
						['itemAxis.title','valueAxis.title']
					]
				},
				'properties':{
					'widget.data.truncate': {
						active: false,
						defaultValue: true
					},
					'itemAxis.title': {
						'multilingual': true
					},
					'color.title': {
						'multilingual': true
					},
					'size.title': {
						'multilingual': true
					},
					'valueAxis.title': {
						'multilingual': true
					},
					'format.compact':{
						'active':false
					},
					'legendPosition':{
						'active':false
					},
					'legend.display':{
						'active':false
					},
					'border.width': {
						'active': false
					},
					'widget.legend.size': {
						'active': false
					},
					'itemAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.title.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'itemAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'valueAxis.ticks.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.legend.titleColor': {
						'colorClass': true,
						'active': true
					},
					'itemAxis.gridLines.color':{
						'colorClass': true,
						'addButton': true
					},
					'valueAxis.gridLines.color':{
						'colorClass': true,
						'addButton': true
					},
					'itemAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'valueAxis.line.color':{
						'colorClass': true,
						'addButton': true
					},
					'itemAxis.ticks.labels.rotateAngle': {
						'percentage': false
					},
					'widget.repeatHorizontal.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					},
					'widget.repeatVertical.labels.color':{
						'colorClass': true,
						'addButton': true,
						'displayPos': 45
					}
				},
				'queryHints':{
					'multiEdgeSort':true
				},
				config:{
					'include':[
						'widget.data.truncate',
						'widget.iterator',
						'widget.legend.display',
						'widget.legend.position',
						'gridLines.visible',
						'itemAxis.title.visible',
						'valueAxis.title.visible',
						'itemAxis.ticks.labels.font',
						'itemAxis.ticks.labels.color',
						'valueAxis.ticks.labels.font',
						'valueAxis.ticks.labels.color',
						'itemAxis.title.font',
						'itemAxis.title.color',
						'valueAxis.title.font',
						'valueAxis.title.color',
						'itemAxis.title',
						'valueAxis.title',
						'itemAxis.labels.layoutMode',
						'itemAxis.alignment', //TODO:'axis.x.alignment',
						'gridlineColor',
						'itemAxis.ticks.color',
						'valueAxis.ticks.color',
						'labelColor',
						'backgroundColor',
						'widget.legend.backgroundColor',
						'optimizeSize',
						'border.width',
						'widget.legend.color',
						'widget.legend.splitter',
						'widget.legend.titleColor',
						'widget.legend.font',
						'widget.legend.titleFont',
						'widget.repeatHorizontal.labels.color',
						'widget.repeatVertical.labels.color',
						'widget.repeatHorizontal.labels.font',
						'widget.repeatVertical.labels.font',
						'itemAxis.ticks.labels.visible',
						'itemAxis.ticks.visible',
						'valueAxis.ticks.labels.visible',
						'valueAxis.ticks.visible',
						'colors.color',
						'widget.legend.size',
						'widget.legend.titleVisible',
						'color.title',
						'size.title',
						'itemAxis.gridLines.color',
						'valueAxis.gridLines.color',
						'itemAxis.line.color',
						'valueAxis.line.color',
						'itemAxis.line.visible',
						'valueAxis.line.visible',
						'itemAxis.ticks.labels.rotateAngle'
					],
					'exclude':[
					]
				},
				'usages':[
					'Relationships',
					'Comparison'
				],
				'supportsMaintainAxisScale': true
			};
		}

	}
	return Rave2heat;
});
